/**
 * LandingStep - Initial modal screen
 *
 * Shows message about full health profile rolling out and gives options
 * to continue or indicate this wasn't what they expected.
 */

interface LandingStepProps {
  onContinue: () => void;
  onNotExpecting: () => void;
}

export function LandingStep({ onContinue, onNotExpecting }: LandingStepProps) {
  return (
    <div className="flex flex-col gap-6">
      {/* Header */}
      <h2 className="text-center text-2xl font-bold text-catch-dark-blue-90">
        Your full health profile is rolling out
      </h2>

      {/* Body text */}
      <div className="flex flex-col gap-4 text-center text-catch-slate">
        <p>
          Catch is built to help you understand long-term health risk across heart
          disease, dementia, diabetes, and cancer.
        </p>
        <p>
          Today, cancer risk modeling is live.
        </p>
        <p>
          Additional health areas are actively rolling out. As an early member
          of Catch, you&apos;ll be the first to get access as they launch.
        </p>
      </div>

      {/* Continue CTA */}
      <button
        onClick={onContinue}
        className="flex w-full items-center justify-center rounded-full bg-catch-avocado-400 px-5 py-4 text-sm font-bold text-catch-dark-blue-90 transition-opacity hover:opacity-90"
      >
        Continue
      </button>

      {/* Not what I expected link */}
      <button
        onClick={onNotExpecting}
        className="w-full text-center text-sm font-medium text-catch-slate underline transition-opacity hover:text-catch-dark-blue-90"
      >
        Not what you were expecting?
      </button>
    </div>
  );
}

export default LandingStep;
